import { TableColumn } from '../../../components/forms/form-entries/form-entry-list/entry-list/dynamic-table/dynamic-table.component';
import { EmployeeInjuryReport } from './employee-injury-report.model';

export class EmployeeInjuryReportListItem {
  /** When the form was submitted ("Entry Date" column) */
  submissionDate: Date | null = null;

  /** The person who submitted the form ("User" column) */
  submittedByName: string = '';

  /** Type of incident */
  typeOfIncident: string = '';

  /** Employee's first name */
  employeeFirstName: string = '';

  /** Employee's last name */
  employeeLastName: string = '';

  /** Employee's street address */
  streetAddress: string = '';

  /** Employee's phone number */
  phone: string = '';

  

  id: string = '';


  constructor(data?: Partial<EmployeeInjuryReportListItem>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  static getTableColumns(): TableColumn[] {
    const columns: TableColumn[] = [];
    const instance = new EmployeeInjuryReportListItem();
    const fieldMappings = EmployeeInjuryReport.getFieldMappings();
    
    // Get all properties of the class
    Object.keys(instance).forEach(key => {
      // Skip the id property as it's handled separately
      if (key === 'id') return;

      // Determine the type based on the property value
      let type: 'text' | 'date' | 'action' | 'status' = 'text';
      const value = instance[key as keyof EmployeeInjuryReportListItem];
      
      if (value instanceof Date || (value === null && key.toLowerCase().includes('date'))) {
        type = 'date';
      }
      // All other values default to 'text' type

      // Add the column if it has a mapping
      if (fieldMappings[key]) {
        columns.push({
          key,
          label: fieldMappings[key],
          type,
          sortable: true
        });
      }
    });

    

    return columns;
  }

  static fromApiResponse(data: any): EmployeeInjuryReportListItem {
    return new EmployeeInjuryReportListItem({
      id: data.id,
      submissionDate: data.submissionDate ? new Date(data.submissionDate) : null,
      submittedByName: data.submittedByName,
      typeOfIncident: data.typeOfIncident,
      employeeFirstName: data.employeeFirstName,
      employeeLastName: data.employeeLastName,
      streetAddress: data.streetAddress,
      phone: data.phone,

    });
  }
} 